import React from 'react';
import { withTranslation } from 'react-i18next';
import Delete from '@material-ui/icons/Delete'
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import KrTypeComp from './key_results/krtype.component';
import MetricComp from './key_results/metric.component';
import CreateWsPopUp from '../../CreateWsPopUp.component';
import DeleteCommonModal from '../../deleteCommonModal.component';
import KrstudioPopup from './krStudioPopup.component';
import KpiMarketPlaceKrWizardPopup from './kpiMarketPlaceKrWizardPopup';
import {Modal, ThemeProvider, ModalWrapper, ModalHeader, ModalContent, IconButton} from '@workboard/wobo-ui';
import { KpiSearchModal } from './kpiSearchModal';
import styled from "styled-components"
import { krdetailConstants } from '../../../constants/krdetails.constants';
import GoalServices from '../../../services/goal.services';
import { reactLoader, removeReactLoader } from '../../../utils/common';
import { buildCustomFieldsDataArray } from "../../custom_fields/utils/buildCustomFieldsDataArray";
import { prepareCustomDataForDisplay } from "../../custom_fields/utils/customFieldsDisplayUtils";
import { resolveKrSaveGoalId } from '../../../utils/kpi-market-place-util';
import { isKeyResultClosed } from '../../../utils/closeKeyResult.util';
import { ClosedKrLockContext } from './closedKrLock.context';

const StyledModal = styled(Modal)`
	.MuiDialog-scrollPaper {
		display: flex;
		align-items: flex-end;
		flex-direction: column;
	}
	.MuiDialog-container{
		height: 100% !important;
	}
	${ModalWrapper} {
		width: 50%;
		height: 100%;
		min-width: 760px;
		margin: 0 !important;
	}
	${ModalHeader} {
		padding: 32px 100px 12px 60px !important;
		h1,h2 {
			font-size: 20px !important;
			display: flex;
			align-items: center;
		}
		svg {
			width: 24px;
			height: 24px;
		}
		button{
			margin-bottom: 0 !important;
			width: 30px;
			height: 30px;
		}
	}
	${ModalContent} {
		padding: 0px !important;
		height: calc( 100% - 190px );
		max-height: calc(100vh - 192px) !important;
		overflow: auto;
		p {
			line-height: 1.5;
			margin: 0;
		}
	}
	${ModalContent} + div {
		margin-right: 75px !important;
		padding-top: 16px !important;
		padding-bottom: 16px !important;
	}
`;

const StyledBackButton = styled(IconButton)`
	svg {
		transform: translateX(5px);
	}
`;

const DeleteKRButton = (props) => {
	const handleDeleteKr = () => {
		props.krDelete(props.krId);
		const { team_id, owner_id} = props.goalDetails;
		window.wb_track('KR_DELETE', {
			UserId: window.uData.user_id,
			OrgId: window.uData.org_id,
			Timestamp: Date.now(),
			TeamId: team_id,
			OwnerId: owner_id,
			KrId: props.krId,
			Source: 'OKR_Wizard',
		});
	};

	return(
		<IconButton
		  id="set-delete-focus"
			style={{marginRight: 10}}
			onClick={handleDeleteKr}
		>
			<Delete />
		</IconButton>
	)
}

const ComplexTitle = (props) => {
	return(
		<>
			{((props.propVal.isChildKr && props.propVal.fromParentKr) || (props.switchedFromMit)) &&
			<div style={{ paddingRight: "12px" }}>
				<StyledBackButton
					id="set-arrowbtn-focus"
					aria-label='Back'
					onClick={props.goBack}
				>
					<ArrowBackIos />
				</StyledBackButton>
			</div>
			}
			{props.headerTitle}
		</>
	)
}
class EditMetric extends React.Component {
	constructor(props) {
		super(props);
		const rawCustomData =
      this.props.item && (this.props.item.customFields || this.props.item.groupKRCustomFields)
        ? this.props.item.groupKRCustomFields
          ? this.props.item.groupKRCustomFields
          : this.props.item.customFields
        : this.props.addOkrData?.groupKRCustomFields || {};
		const customData = prepareCustomDataForDisplay(rawCustomData);
		this.state = {
			rightokrpane: " openLeftPane",
			errors: {},
			metricObj: {},
			krType: this.props.krType,
			krId: this.props.item && this.props.item.id ? this.props.item.id : "",
			krAssociation: this.props.item && this.props.item.krAssociation ? this.props.item.krAssociation : {},
			createWsPopUp: false,
			openKrstudioPopup: false,
			openExternalDataSourcePopup: false,
			openKpiSearchModal: false,
			wsData: {},
			showKrTypeOptions: false,
			confirmDialog: false,
			nested_krs: this.props.item && this.props.item.nested_krs ? this.props.item.nested_krs : null,
			child_kr_duration: (this.props.isChildKr || this.props.mitChildKr)
												? this.props.item && this.props.item.startDateText
													? this.props.goalDetails.metricQuarterOption.find((opt) => (opt.start == this.props.item.startDateText && opt.end == this.props.item.endDateText))
													: this.props.basicInlineData && this.props.basicInlineData.duration
														? this.props.basicInlineData.duration
														: this.props.goalDetails.metricQuarterOption[0]
												: null,
			newNestedKr: false,
			//isNestedKrTitle: this.props.item && this.props.item.nested_krs && this.props.item.nested_krs.length > 0 ? true : false
			kpiType: this.getKpiTypeFromItem(),
			selectedKpiData: null,
			selectednlplTags:this.props.selectednlplTags,
			selectednlplTagsName:this.props.selectednlplTagsName,
			nplTags:this.props.nplTags,
			tagsList:this.props.tagsList,
			shouldShowDismissButton: true,
			customData,
			customFieldsData: buildCustomFieldsDataArray(customData, '6', true), // for API payload
		};

		this.handleCustomFieldsChange = this.handleCustomFieldsChange.bind(this);
		this.setRightPaneValue = this.setRightPaneValue.bind(this);
		this.clickKrTypeText = this.clickKrTypeText.bind(this);
		this.saveKrData = this.saveKrData.bind(this);
		this.cancelKR = this.cancelKR.bind(this);
		this.changeDataSourceOption = this.changeDataSourceOption.bind(this);
		this.closeWsPopUp = this.closeWsPopUp.bind(this);
		this.openMSKRPopUp = this.openMSKRPopUp.bind(this);
		this.continueMSKRPopUp = this.continueMSKRPopUp.bind(this);
		this.disCardKRSPopUp = this.disCardKRSPopUp.bind(this);
		this.closeKpiSearchModal = this.closeKpiSearchModal.bind(this);
		this.handleSaveWoboKpi = this.handleSaveWoboKpi.bind(this);
		this.onSaveWoboKpi = this.onSaveWoboKpi.bind(this);
		this.exitMSKRPopUp = this.exitMSKRPopUp.bind(this);
		this.setCreateWs = this.setCreateWs.bind(this);
		this.getDataSource = this.getDataSource.bind(this);

		this.exitKpiMarketPlacePopup = this.exitKpiMarketPlacePopup.bind(this);
		this.continueKpiMarketPlace = this.continueKpiMarketPlace.bind(this);
		this.saveKpiMarketPlaceData = this.saveKpiMarketPlaceData.bind(this);
		this.cancelKpiTypeSelection = this.cancelKpiTypeSelection.bind(this);
	}

	getKpiTypeFromItem() {
		if (!this.props.item) {
			return null;
		}

		const source = this.props.item.source;
		const externalAppId = +this.props.item.ext_app_id;
		if (source == 10) {
			return 'ds';
		}

		const legacyExAppId = new Map([
			[5, 'jira'],
			[6, 'asa'],
			[13, 'ado'],
			[11, 'ms']
		]);

		return (source == 8 && legacyExAppId.has(externalAppId)) ? legacyExAppId.get(externalAppId) : null;
	}

	handleCustomFieldsChange(customData) {
		this.setState({
			customData,
			customFieldsData: buildCustomFieldsDataArray(customData, '6'), // for API payload
		});
	}

	static getDerivedStateFromProps(props, state) {
		let newState = {...state};

		if(state.nested_krs && state.nested_krs.length > 0 && !state.nested_krs[0].duration){
			let gDetails = props.goalDetails;
			let newNestedKrs = state.nested_krs.map((kr) => {
				// let { startDateText, endDateText, ...krData } = kr;
				return {
					...kr,
					duration: gDetails.metricQuarterOption.find((opt) => (opt.start == kr.startDateText && opt.end == kr.endDateText))
				}
			});
			newState.nested_krs = newNestedKrs;
		}
		return newState;
	}

	componentDidMount() {
		//$(window).scrollTop(0);
		overflowHiddenFunction(true);
		let windowHeight = $(window).height();
		$("#mySidenav .krRightPaneContent").css({
			"min-height": windowHeight - 244,
			"max-height": windowHeight - 244
		});
	}

	componentWillUnmount() {}

	updateNestedKrs = (data, action, index) => {
		let krs = this.state.nested_krs ? [...this.state.nested_krs] : [];
		if(data && !data.source){
			data.source = 1;
		}
		if(data && !data.id ){
			if(data.ext_source_name && !data.name){
				data.name = data.ext_source_name;
				data.metricJira = {
					ids: data.project_ids
				};
			}
			if(data.source ){
				if(data.source == 2){
					data.progress = -1;
				}
			}
			if(data.owner && !data.owner_fullname && data.ownerName){
				data.owner_fullname = data.ownerName;
				data.owner_pic = data.ownerPic;
			}
		}
		if(data && !data.duration){
			if(data.id){
				data.duration = this.props.goalDetails.metricQuarterOption.find((opt) => (opt.start == data.startDateText && opt.end == data.endDateText))
			}else{
				data.duration = this.props.goalDetails.metricQuarterOption.find((opt) => (opt.start == data.start_date && opt.end == data.end_date))
			}
		}
		if (data.duration) {
			data.startDateText = data.duration.start;
			data.endDateText = data.duration.end;
		}
		if (!data.hasOwnProperty('stretchTarget')) {
			data.inline = true;
		}
		if(action === "add"){
			krs.push(data);
		}else if(action === "delete"){
			krs.splice(index, 1);
		} else if (action === "update"){
			if(data.id && !data.ignoreIdCheck){
				let indexOfKr = krs.findIndex((k) => k.id === data.id);
				krs[indexOfKr] = {
					...krs[indexOfKr],
					...data
				};
			}else{
				krs[index] = data;
			}
		}
		this.setState({
			nested_krs: krs
		});
    }

	setRightPaneValue() {
		this.setState({ rightokrpane: " closeLeftPane ", errors: {} });
	}

	backToKrTypeSelector() {
		this.setState({
			krType: '',
			kpiType: null,
			errors: {},
			openExternalDataSourcePopup: false,
			openKpiSearchModal: false,
		});
	}

	clickKrTypeText(item) {
		const { t } = this.props;
		if (typeof item.clickable !== 'undefined' && !item.clickable) {
			return;
		}
		this.setState({ krType: item.id, errors: {} });

		if (item.id === 'krstudio') {
			this.setState({ openKrstudioPopup: true });
		}
		else if (item.id === 'kpi' || item.id === 'wobo_kpi' || item.id === 'kpi-modal') {
            if ((!this.props.isChildKr && this.props.item?.name && this.props.item.name == '') || (!this.props.isChildKr && this.props.addKrValue == '' && !this.props.item?.name ) || (this.props.isChildKr && this.props?.basicInlineData?.name === '' )) {
				let errors = {};
      			errors['krText'] = t('Enter the metric name.');
				this.setState({ openExternalDataSourcePopup: false, errors });
			} else {
				if (item.id === 'kpi-modal') {
					this.setState({
						openKpiSearchModal: true,
						krType: 'kpi'
					});
				} else {
					this.setState({ openExternalDataSourcePopup: true });
				}
			}
		} else {
			this.setState({ krAssociation: {} });
		}
	}

	changeDataSourceOption = (itemObj) => {
		this.setState({ krType: '', kpiType: null, errors: {} });
		const { isChildKr, nestedKrAction, nestedKrIndex,
			item = {}, basicInlineData} = this.props;
		if (typeof this.props.updateKRDataObject !== undefined && typeof this.props.updateKRDataObject === 'function') {

				if (isChildKr) {
					const val = document.querySelector('[data-kr-id="metric-child-kr-name-text"]').value;
					if (basicInlineData) {
						if (basicInlineData.name != val) {
							this.props.updateKRDataObject(val, item, {...basicInlineData, name: val}, nestedKrIndex, nestedKrAction);
						}
					}
				} else if(this.props.mitChildKr){
					this.props.updateKRDataObject();
				} else {
					const val = document.getElementById("metric-name-text") ?  document.getElementById("metric-name-text").value : "";
					item.target = document.querySelector('[name="target"]')?.value ?  document.querySelector('[name="target"]').value : "";
					item.stretch_target = document.querySelector('[name="stretch"]') ?  document.querySelector('[name="stretch"]').value : "";
					item.initial_data = document.querySelector('[name="initial_data"]') ?  document.querySelector('[name="initial_data"]').value : "";
					if (val != item.name && val != '') {
						this.props.updateKRDataObject(val, item);
					}
				}
		}
	}
	cancelKR(){
		let { krType, kpiType } = this.state;
		if (krType != ""){
			if ( krType == 'rollupokrs' || krType == 'survey' || krType == 'cascade') {
				this.comboMetricRef?.handleCancel();
			} else if ( krType == 'person' ||
				krType == 'krstudio' ||
				krType == 'multipleIntervalTargets' ||
				krType == 'multipleIntervalLongTargets' ||
				krType == 'workstream'
			) {
				this.metricRef?.setRightPaneValue()
			} else if (krType == 'mirrorkr') {
				this.props.closeKrRightPane()
			} else if (krType == 'kpi' || krType == 'kpi-modal') {
				if( kpiType == "" || kpiType == null || kpiType == "ms") {
					if (this.metricRef && typeof this.metricRef.handleCancel === 'function') {
						this.metricRef.handleCancel();
					} else {
						this.backToKrTypeSelector();
					}
				} else if (kpiType == "wobo_kpi") {
					if (this.kpiRef && typeof this.kpiRef.handleCancel === 'function') {
						this.kpiRef.handleCancel();
					} else if (this.metricRef && typeof this.metricRef.handleCancel === 'function') {
						this.metricRef.handleCancel();
					} else {
						this.backToKrTypeSelector();
					}
				} else if (kpiType == "ado" || kpiType == "ds" || kpiType == "asana" || kpiType == "asa" || kpiType == "jira") {
					this.kpiRef?.handleCancel?.()
				} else {
					this.kpiRef?.setRightPaneValue()
				}
			}
		} else {
			this.props.closeKrRightPane(false,this.state.krId)
		}
	}

	saveKrData(e) {
		const { t } = this.props;
		e.preventDefault();
		let { krType, kpiType } = this.state;
		if (krType != ""){
			if ( krType == 'rollupokrs' || krType == 'survey' || krType == 'cascade') {
				this.comboMetricRef?.saveMetricData();
			} else if ( krType == 'person' ||
				krType == 'krstudio' ||
				krType == 'multipleIntervalTargets' ||
				krType == 'multipleIntervalLongTargets' ||
				krType == 'workstream'
			) {
				this.metricRef?.saveKr()
			} else if (krType == 'mirrorkr') {
				this.metricRef?.saveLinkedKR()
			} else if (krType == 'kpi') {
				if( kpiType == "" || kpiType == "ms") {
					this.metricRef?.saveMetricData()
				} else if (kpiType == "wobo_kpi") {
					this.kpiRef?.saveKr()
				} else if (kpiType == "ds") {
					this.kpiRef?.validateDsKr();
				} else if (kpiType == "asana"  || kpiType == "asa") {
					this.kpiRef?.validateAsanaKr()
				} else if (kpiType == "jira") {
					this.kpiRef?.validateJiraKr()
				} else if (kpiType == "ado") {
					this.kpiRef?.handleSave()
				} else {
					this.kpiRef?.saveKr()
				}
			}
		} else {
			let errors = {};
			if (krType == "") {
				errors["krType"] = t("Select a type of data source");
			}
			if (Object.keys(errors).length) {
				this.setState({ errors});
			}
		}
	}

	openMSKRPopUp() {
		this.setState({
			krType: 'krstudio',
			errors: {},
			openKrstudioPopup: true
		});
	}

	continueMSKRPopUp(krAssociation) {
		this.setState({ openKrstudioPopup: false });
		if (krAssociation.constructor === Object && Object.keys(krAssociation).length === 0) {
			this.setState({ krType: this.props.krType || 'person' });
		} else {
			this.setState({ krType: 'krstudio', krAssociation });
		}
	}

	disCardKRSPopUp(){
		this.setState({
			openKrstudioPopup: false
		});
	}


	exitMSKRPopUp() {
		this.setState({
			krType: this.props.krType || 'person',
			openKrstudioPopup: false
		});
	}

	closeWsPopUp(MainWS) {
		if (MainWS != undefined) {
			this.setState({
				wsData: MainWS,
				createWsPopUp: false
			});
		} else {
			this.setState({
				createWsPopUp: false
			});
		}
	}

	exitKpiMarketPlacePopup() {
		this.setState({ openExternalDataSourcePopup: false, krType: this.props.krType, kpiType: this.getKpiTypeFromItem()});
	}

	cancelKpiTypeSelection(kpiType) {
		const krType = this.state.krType;
		this.setState({ krType: 'person', kpiType: kpiType });
		this.setState({ krType: krType });
    }

	continueKpiMarketPlace(kpiObject) {
		this.setState({ krType: 'person', openExternalDataSourcePopup: false});
		if (kpiObject.kpiType) {
			this.setState({ kpiType: kpiObject.kpiType });
			this.setState({ krType: 'kpi' });
		}
	}

	saveKpiMarketPlaceData(metric) {
		const storeKrTypeState = this.state.krType;
		if (this.props.updateSingleItem) {
			this.props.updateSingleItem(metric);
		}
		this.setState({ openExternalDataSourcePopup: false, krType: 'person' });
		this.setState({ krType: storeKrTypeState, kpiType: null});
	}

	handleSaveWoboKpi (selectedKpi) {
    reactLoader();
		const goalService = new GoalServices();
		const goalId = resolveKrSaveGoalId(this.props.item, this.props.addOkrData?.goalDetails || this.props.goalDetails);
		const name = $('#metric-name-text').val() || this.props.addKrValue;
		const realOwnerId = this.props.realOwner ? this.props.realOwner.id : this.props.item.real_owner;
		const payload = {
			...this.props.item,
			name: name,
			source: krdetailConstants.SOURCE_EXT_SOURCES,
			ext_app_id: krdetailConstants.WOBO_KPI_ID,
			real_owner: realOwnerId,
			owner: realOwnerId,
			kpiId: selectedKpi.id,
			external_app_sources: [{
				id: selectedKpi?.id,
				external_app_id: krdetailConstants.WOBO_KPI_ID,
				data: JSON.stringify({
					kpiId: selectedKpi?.id,
				})
			}],
		}

		if (this.props.mitChildKr) {
			const offsetUpdateValue = this.props.item?.offset_update != null && this.props.item.offset_update !== ''
				? +this.props.item.offset_update
				: null;
			payload.achieve_target = this.props.item?.achieve_target ?? 0;
			payload.start_date = this.props.item.start_date;
			payload.end_date = this.props.item.end_date;
			payload.quarter_name = 'Q' + ((this.props.mitIndex ?? 0) + 1);
			payload.offset_update = offsetUpdateValue;
			removeReactLoader();
			if (typeof this.props.saveQuarterlyKR === 'function') {
				this.props.saveQuarterlyKR(payload, this.props.mitIndex);
			}
			return Promise.resolve({ ...payload });
		}

		// Remove start_date and end_date for KPI automation (they should only be included for mitChildKr or isChildKr && fromParentKr)
		delete payload.start_date;
		delete payload.end_date;

		return goalService
			.addEditKr({ goalId: goalId, metric: payload })
			.then(res => {
				if (res && res.data?.data) {
					if (!this.props.onlyMetEdit && this.props.actions && this.props.actions.addNewKr) {

						if (!this.props.isChildKr && !this.props.fromParentKr) {
							this.props.actions.addNewKr(res.data.data);
						}

						if (this.props.closeKrRightPane && !this.props.saveKrComplete) {
							this.props.closeKrRightPane(true)
						}
					}
				}
				removeReactLoader();
				console.log('payload', payload);
				const returnMetric = res.data.data;
				returnMetric.achieve_target = payload.achieve_target??0;
				console.log('returnMetric', returnMetric);
				return { ...payload, ...returnMetric};
			}).catch(() => {
				removeReactLoader();
			});
  }

	async getDataSource(metric) {
    metric = metric || this.props.item;
    if (!metric.id) {
      return null;
    }
    const goalService = new GoalServices();
    const response = await goalService.getDataSource({ metricId: metric.id });
    let dataSource = response.data?.data?.dataSource?.extSource;
    if (typeof dataSource?.data === 'string') {
      dataSource.data = JSON.parse(dataSource.data);
    }
    return dataSource;
  }

	async onSaveWoboKpi(selectedKpi) {
		const metric = await this.handleSaveWoboKpi(selectedKpi);
		if (!metric) {
			return;
		}
		// const dataSource = await this.getDataSource(metric);
		// Call updateSingleItem to save the KR (similar to saveKpiMarketPlaceData)
		const storeKrTypeState = this.state.krType;
		if (this.props.updateSingleItem) {
			this.props.updateSingleItem(metric);
		}

		this.setState({
			openKpiSearchModal: false,
			krType: 'kpi',
			kpiType: 'wobo_kpi',
			selectedKpiData: selectedKpi
		});

		// Reset krType state similar to saveKpiMarketPlaceData
		this.setState({ krType: storeKrTypeState });
	}

	closeKpiSearchModal(canceled = false) {
		this.setState({
			openKpiSearchModal: false,
		});

		if (canceled) {
			this.setState({
				krType: this.props.krType,
				// kpiType: this.getKpiTypeFromItem()
			});
		}
	}

	setCreateWs() {
		this.setState({
			createWsPopUp: !this.state.createWsPopUp
		});
	}

	toggleConfirmDialog = (bool, data, index) => {
    this.setState((prevState) => {
      return {
        confirmDialog: !prevState.confirmDialog,
        // metricToBeOperated : data ? data : null,
        // indexToBeOperated: index ? index : null
      }
    })
  }

	addAnotherNestedKr = (bool, allowPostAction, fromMit ) => {
		let isConfirmDialogOpen = this.state.confirmDialog;
		if(this.state.confirmDialog){
			this.toggleConfirmDialog();
		}

    this.setState({
      newNestedKr: bool,
    }, () => {
      if(allowPostAction){
        if(!bool){
          if(this.state.switchedFromMit){
            this.setState({
              switchedFromMit: false,
            }, () => {
              this.clickKrTypeText({
                clickable: () => null,
                id: "multipleIntervalTargets"
              })
            })
          }else if(isConfirmDialogOpen){
            this.props.closeKrRightPane(false, this.state.krId)
          }
        }
        if(fromMit){
          this.setState({
            switchedFromMit: fromMit
          }, () => {
            this.clickKrTypeText({
              clickable: () => null,
              id: "person"
            })
          })
        }
      }
    });


  }

	goBack = ()  => {
		if(this.props.isChildKr && this.props.fromParentKr){
			this.props.closeKrRightPane(false,this.state.krId);
		} else if (this.state.switchedFromMit || (this.state.nested_krs && this.state.nested_krs.length > 0) || this.state.newNestedKr ){
			this.toggleConfirmDialog();
		}
	}

	onDurationChange = (val) => {
		this.setState({
			child_kr_duration: val
		});
	}

	handleShowDismissButtonChange = (showDismissButton) => {
		this.setState({
			shouldShowDismissButton: showDismissButton
		});
	}

	render() {
		return (
			<ClosedKrLockContext.Provider value={isKeyResultClosed(this.props.item)}>
				{this.renderEditPanel()}
			</ClosedKrLockContext.Provider>
		);
	}

	renderEditPanel() {
		const { t } = this.props;
		let headerTitle = `${t('Create Key Result')} ${this.state.switchedFromMit ? t('With Supporting Quarterly Key Results') : ''}`;
		let krType = this.state.krType;
		let editFlag = false;
		if (
			Object.keys(this.props.item).length &&
			typeof this.props.item.id !== "undefined"
		) {
			headerTitle = t('Edit Key Result');
			editFlag= true;
		}
		if (krType == "mirrorkr") {
			headerTitle = t('Link to Existing Key Result');
		}
		if(this.props.isChildKr){
			if(!this.props.item.parent){
				headerTitle = t('Create Supporting Quarterly Key Result');
			} else{
				headerTitle = t('Edit Supporting Quarterly Key Result');
			}
		}
		let mNameText = document.getElementById("metric-name-text");
		return (
			<ThemeProvider>
				<StyledModal
					className="aE-Edit-Metric"
					dismissLabel={t("Cancel")}
					submitLabel={t("Save")}
					removeDismiss={!this.state.shouldShowDismissButton}
					isOpen={true}
					onDismiss={() => this.cancelKR()}
					onSubmit={(e) => this.saveKrData(e)}
					removeClose
					title={<ComplexTitle
						propVal={this.props}
						headerTitle={headerTitle}
						goBack={this.goBack}
						switchedFromMit={this.state.switchedFromMit}
					/>}
					toolbar={() => (!this.props.mitChildKr && !this.props.isOwnerOfCascade && <DeleteKRButton goalDetails={this.props.goalDetails} krDelete={this.props.krDelete} krId={this.state.krId} />)}
					style={{ zIndex: '1000000', padding: 0, alignItems: 'flex-end', flexDirection: 'column' }}
					disableEnforceFocus
				>
					<div className="krRightPaneContent">
					{
						krType != "" ?
							<MetricComp
								changeDataSourceOption={this.changeDataSourceOption}
								{...this.props}
								krType={krType}
								 errors={this.state.errors}
								comboMetricRef={ref => (this.comboMetricRef = ref)}
								metricRef={ref => (this.metricRef = ref)}
								kpiRef={ref => (this.kpiRef = ref)}
								kpiType={this.state.kpiType}
								selectedKpiData={this.state.selectedKpiData}
								krAssociation={this.state.krAssociation}
								resetKrAssociation={this.openMSKRPopUp}
								kr_ui_wizard={!mNameText ? this.props.addOkrData.kr_ui_wizard : undefined}
								setCreateWs={this.setCreateWs}
								wsData={this.state.wsData}
								MetricChangeWeight={this.props.MetricChangeWeight}
								krTextForWS={mNameText ? mNameText.value : undefined}
								addEditFlag={editFlag}
								lastType={this.props.krType}
								//isNestedKrTitle={this.state.isNestedKrTitle}
								//updateNestedKrTitle={this.updateNestedKrTitle}
								addAnotherNestedKr={this.addAnotherNestedKr}
								newNestedKr = {this.state.newNestedKr}
								updateNestedKrs = {this.updateNestedKrs}
								nested_krs = {this.state.nested_krs}
								childKrDuration = {this.state.child_kr_duration}
								updateChildKrDuration = {this.onDurationChange}
								switchedFromMit = {this.state.switchedFromMit}
								goBackFromMitNestedKr = {this.state.switchedFromMit || (this.state.nested_krs && this.state.nested_krs.length > 0 && this.state.nested_krs.filter((nk) => !nk.id).length > 0) || this.state.newNestedKr ? this.goBack : null}
								cancelKpiTypeSelection={this.cancelKpiTypeSelection}
								selectednlplTags={this.state.selectednlplTags}
								selectednlplTagsName={this.state.selectednlplTagsName}
								tagsList={this.state.tagsList}
								nplTags={this.state.nplTags}
								groupKRCustomFields={this.props.groupKRCustomFields}
								onShowDismissButtonChange={this.handleShowDismissButtonChange}
								customFieldsData={this.state.customFieldsData}
								customData={this.state.customData}
								onCustomFieldsChange={this.handleCustomFieldsChange}
							/>
					:
						<KrTypeComp
							clickKrTypeText={this.clickKrTypeText}
							errors={this.state.errors}
							MetricChangeWeight={this.props.MetricChangeWeight}
							addEditFlag={editFlag}
							lastType={this.props.krType}
							isZenry={this.props.addOkrData.isZenryDomain}
							kr_relationship={this.props.addOkrData.kr_relationship}
							kr_ui_wizard={this.props.addOkrData.kr_ui_wizard}
							goalDetails={this.props.goalDetails}
							isChildKr={this.props.isChildKr}
							displayNestedKr={this.props.addOkrData.display_nested_kr}
							integrations={this.props.integrations}
							mitChildKr = {this.props.mitChildKr}
							mitIndex={this.props.mitIndex}
							item={this.props.item}
						/>
					}

					</div>

				{this.state.createWsPopUp && (
					<CreateWsPopUp
						closeWsPopUp={this.closeWsPopUp}
					/>
				)}
				{this.state.openExternalDataSourcePopup && (
					<KpiMarketPlaceKrWizardPopup
						{...this.props }
						closePopUp={this.exitKpiMarketPlacePopup}
						continue={this.continueKpiMarketPlace}
						saveKrComplete={this.saveKpiMarketPlaceData}
					/>
				)}

				{this.state.openKrstudioPopup && (
					<KrstudioPopup
						keyResult={this.props.item}
						keyResultName={this.props.addKrValue}
						krAssociation={this.state.krAssociation}
						iframeSrc={this.props.addOkrData.ext_app_iframe_source}
						objective={this.props.addOkrData.goalDetails}
						closePopUp={this.exitMSKRPopUp}
						continue={this.continueMSKRPopUp}
						discard={this.disCardKRSPopUp}
					/>
				)}
				{
					this.state.confirmDialog
					&& (
					<DeleteCommonModal
						controlStyle={{
							'deleteModalContent' : {padding: 24, minHeight: 122},
							'deleteModalTitle' : {padding: 0},
							'deleteModalContentSub': {paddingLeft: 2, margin: 'unset'},
							'deleteModalFooter': {height: 0, paddingRight: 0},
							'deleteCancel' : {margin: 0}
						}}
						exitDeleteModal={this.toggleConfirmDialog}
						deleteItems={() => this.addAnotherNestedKr(false, true)}
						title={t("Go back without saving?")}
						// deleteContentOne="Are you sure you want to"
						// deleteContentSecond={`leave without saving your ${t('key result')}?`}
						buttonText={t("Continue")}
						// deleteContentSecondParam={`delete ${t('key result')}?`}
						// deletefirstTitle={`Delete ${t('Key Result')}`}
						btnStyle = {{background: "#007FAD", color: "#ffffff"}}
						deleteContentBodyText={t('Are you sure you want to return to the previous screen? Any key result data entered on this page will not be saved.')}
						id={this.state.metricToBeOperated && this.state.metricToBeOperated.id ? this.state.metricToBeOperated.id : "" }
					/>
					)
				}

				{this.state.openKpiSearchModal && (
					<KpiSearchModal
						metric={this.props.item}
						onSave={this.onSaveWoboKpi}
						onClose={this.closeKpiSearchModal}
					/>
				)}
			</StyledModal>
		</ThemeProvider>
		);
	}
}

export default withTranslation()(EditMetric);
